import { render, staticRenderFns } from "./MagatzemList.vue?vue&type=template&id=0e7f94d9&scoped=true"
import script from "./MagatzemList.vue?vue&type=script&lang=js"
export * from "./MagatzemList.vue?vue&type=script&lang=js"
import style0 from "./MagatzemList.vue?vue&type=style&index=0&id=0e7f94d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7f94d9",
  null
  
)

export default component.exports